import { Lock } from 'lucide-react';

/**
 * Petit cadenas discret fixé en bas à droite de l'écran.
 * Sert d'indicateur visuel quand une page / section est en lecture seule
 * (remplace les anciens bandeaux "Mode lecture seule …" qui étaient trop envahissants).
 */
export function ReadOnlyLockBadge({ title = 'Mode lecture seule' }) {
    return (
        <div
            className="fixed bottom-4 right-4 z-[60] w-10 h-10 rounded-full bg-slate-700/85 text-white shadow-lg flex items-center justify-center pointer-events-none"
            title={title}
            data-testid="readonly-lock-badge"
            aria-label={title}
        >
            <Lock size={16} strokeWidth={2.25} />
        </div>
    );
}
